module.exports = __webpack_public_path__ + "static/media/logowanie-tab-swieta.53671797.png";